<script setup lang="ts">
import type { PropType } from "vue";

import { ALERT_STATUS } from "~/common/interfaces/alert-status.enum";

const props = defineProps({
	title: {
		type: [String, Number],
		default: "Title"
	},
	description: {
		type: [String, Number],
		default: "Description"
	},
	status: {
		type: String as PropType<ALERT_STATUS>,
		required: true,
		validator (value: ALERT_STATUS) {
			return [ALERT_STATUS.SUCCESS, ALERT_STATUS.WARN, ALERT_STATUS.ERROR, ALERT_STATUS.INFO].includes(value);
		}
	}
});
const emit = defineEmits(["close"]);

const alertStatusMapping = {
	[ALERT_STATUS.SUCCESS]: { icon: "check-circle-20", color: "text-emerald-400" },
	[ALERT_STATUS.WARN]: { icon: "alert-20", color: "text-yellow-400" },
	[ALERT_STATUS.ERROR]: { icon: "x-circle-20", color: "text-rose-400" },
	[ALERT_STATUS.INFO]: { icon: "alert-20", color: "text-blue-400" }
};
const classNames = computed(() => alertStatusMapping[props.status]);
let timerId: any = null;

const startClosingTimer = () => {
	clearClosingTimer();
	timerId = setTimeout(() => {
		emit("close");
	}, 3000);
};

const clearClosingTimer = () => {
	clearTimeout(timerId);
};

onMounted(() => {
	startClosingTimer();
});

onUnmounted(() => {
	clearClosingTimer();
});
</script>

<template>
	<Transition
		enter-from-class="opacity-0 translate-y-4"
		leave-to-class="opacity-0 translate-y-4"
		enter-active-class="transition ease-in-out duration-500"
		leave-active-class="transition ease-in-out duration-500"
		mode="out-in"
		appear
	>
		<li class="flex gap-x-4 bg-gray-900 p-4 rounded-sm w-[336px]">
			<div>
				<NuxtIcon :name="classNames.icon" class="text-[20px]" :class="classNames.color" />
			</div>
			<div class="text-gray-0 text-sm select-none w-[240px]">
				<span class="block font-semibold">{{ title }}</span>
				<span class="whitespace-pre-line">{{ description }}</span>
			</div>
			<div>
				<NuxtIcon name="x-20" class="text-[20px] text-gray-400 hover:cursor-pointer" @click="$emit('close')" />
			</div>
		</li>
	</Transition>
</template>
